<script>
  import SvelteTooltip from "svelte-tooltip";
  import { onMount } from "svelte";
  export let question;
  export let addInitialData;
  export let modifyData;
  export let errors;
  let error = null;

  onMount(async () => {
    addInitialData({
      question_uuid: question.uuid,
      value: ""
    });
  });

  function changeInputValue(value) {
    error = null;
    modifyData({
      question_uuid: question.uuid,
      value: value
    });
  }

  $: if (errors && errors.length > 0) {
    const findError = errors.find(err => err.uuid === question.uuid);

    if (findError) {
      error = findError;
    }
  }
</script>

<div class="px-4">
  <h3 class="text-3 mb-1">
    {question.description}{question.required ? ' *' : ''}:
  </h3>
  <div class="form-group mb-1">
    {#if 'answers' in question}
      <span class="text-2">
        {#if question.answers[0].answer != ''}
          {question.answers[0].answer}
        {:else}
          <span class="font-italic">Sin respuesta</span>
        {/if}
      </span>
    {:else}
      <input
        name="name"
        type="text"
        required={question.required}
        on:input={e => changeInputValue(e.target.value)}
        class={`form-control inputs ${error ? 'is-invalid' : ''}`} />
      {#if error}
        <div class="invalid-feedback">{error.errors}</div>
      {/if}
    {/if}
  </div>
</div>
